// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LK3Tc {\n  height: var(--spacing-md);\n}\n\n.PByLW {\n  width: 70%;\n}\n\n@media screen and (max-width: 1020px) {\n  .PByLW {\n    width: 100%;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spacer": "LK3Tc",
	"emptyState": "PByLW"
};
export default ___CSS_LOADER_EXPORT___;
